import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICompleteDriverTripDto } from 'src/core/interfaces/IComplete-driver-trip';
import { ILoadingOrder } from 'src/core/interfaces/loading-order';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) {}

  getVehicleLocationByLoadingOrderId(id: number): Observable<any> {
    return this.http.get<any>(`${this._baseUrl}/tracking/GetVehicleLocationByLoadingOrderId/${id}`);
  }

  GetAllVehiclesLocations(): Observable<any> {
    return this.http.get<any>(`${this._baseUrl}/Tracking/GetAllVehiclesLocations`);
  }

  GetAllReadyLoadingOrders(): Observable<any> {
    return this.http.get<any>(`${this._baseUrl}/Tracking/GetAllReadyLoadingOrders`);
  }
}
